import React, { useState } from "react";
import SetupReward from "./setupReward";

const Reward = () => {
  const [totalDiscount, setTotalDiscount] = useState("");

  return (
    <div className="relative px-4 md:pl-53px md:pr-87px">
      <div className="mmd:flex-row md:flex md:justify-between">
        <div>
          <p className="mt-5 font-PoppinsSemiBold text-ft22-26.82-0.4 text-black-131426">
            Setup Rewards
          </p>
          <p className="font-PoppinsRegular text-ft15-22.5-0.3 text-grey-575757 ">
            Setup the discount users will receive for providing different types
            of consents.
          </p>
        </div>
      </div>
      <SetupReward
        totalDiscount={totalDiscount}
        setTotalDiscount={setTotalDiscount}
      />
    </div>
  );
};

export default Reward;
